export const USERNAME_RE = /^[a-zA-Z0-9_-]{3,20}$/;

export function isValidUsername(username) {
  return USERNAME_RE.test(String(username ?? ""));
}

export function isValidPassword(password) {
  return typeof password === "string" && password.length >= 8;
}
